
































































import { AttributesHelper } from "../../lib/utils/AttributesHelper";
import { Vue, Component, Prop } from "vue-property-decorator";
import AnxIcon from "../AnxIcon/AnxIcon.vue";
import AnxHrLine from "../AnxHrLine/AnxHrLine.vue";
import AnxLink from "../AnxLink/AnxLink.vue";

/**
 * The *anx-footer* is a simple footer that is displayed on the bottom of the page
 */
@Component({ components: { AnxIcon, AnxHrLine, AnxLink } })
export default class AnxFooter extends Vue {
  /** The id for the footer */
  @Prop({ default: null }) id!: string | null;

  /** The links for the footer */
  @Prop({ default: null }) links!: Array<{ text: string; link: string }> | null;

  /** The icon for the footer. If you want to use images, use the named slot "icon". When providing *null*, no icon is rendered */
  @Prop({ default: "anexia" }) icon!: string | null;

  /**Specify the width of the Footer. Due to the padding, the provided width is not the actual width (530px => 500px real width)*/
  @Prop({ default: "530px" }) width!: string;

  /** This is the margin top for the footer */
  @Prop({ default: "0px" }) marginTop!: string;

  /** This is the name of the company that will be displayed in the footer */
  @Prop({ default: "Anexia Internetdienstleistungs GmbH" })
  companyName!: string;

  /** Show a copyright note in the footer */
  @Prop({ default: true }) showCopyrightDate!: boolean;

  /** The founding date for the copyright note */
  @Prop({ default: 2006 }) copyrightDateFrom!: number;

  get cssProps() {
    return {
      "--width": this.width
    };
  }

  private footerLinks: Array<object> = [];

  /** The current state of the footer, if it is fixed to bottom or not */
  private bottom = false;

  /** If the document height is to less, the footer should be fixed to the bottom of the page */
  private setFooter() {
    const footer = document.getElementById("anx-footer") as HTMLElement;

    /** Check if the footer has been found and is on the page */
    if (footer) {
      /** If the footer is fixed to bottom, the height has to be added to document.body.scrollHeight */
      let documentHeight = document.body.scrollHeight;
      if (this.bottom) documentHeight += footer.scrollHeight;

      /** Compare the height of the document with the actual window height */
      if (documentHeight < window.innerHeight) {
        footer.classList.add("bottom");
        this.bottom = true;
      } else {
        footer.classList.remove("bottom");
        this.bottom = false;
      }
    }
  }

  private mounted() {
    this.setFooter();
    /** Set footer on window resize */
    window.addEventListener("resize", this.setFooter);
    /** Additionally add a listener for height change of document.body */
    this.onElementHeightChange(document.body, this.setFooter);
  }

  /**
   * Attrbibutes for the component
   * Passing this attributes with v-bind allows to not pass unused items
   */
  private get attributes() {
    return AttributesHelper.attributes(this);
  }

  /** Custom function to listen on height change of elements */
  private onElementHeightChange(elm: HTMLElement, callback: () => void) {
    let lastHeight = elm.clientHeight,
      newHeight;
    (function run() {
      newHeight = elm.clientHeight;
      if (lastHeight != newHeight) callback();
      lastHeight = newHeight;

      window.setTimeout(run, 100);
    })();
  }
}
